import React, { useEffect, useState } from "react";
import { OnlinePresenceType } from "../../../../redux/auth/authTypes";
import { formatDate } from "../../../../utils/commonFunctions";
type AppProps = {
  data: any;
  isEdit?:boolean|string;
  fixedAssetDetails: (data: any) => void
  
};
const FixedAssetDetails = ({ data,isEdit,fixedAssetDetails }: AppProps) => {
  const [finalData,setFinalData] = useState<any>([])

  useEffect(()=>{
   if(data?.length>0){
    let arr:any=[]
    data?.map((item:any)=>{
      item?.reporting_details?.far_assigned_details?.map((finalItem:any)=>{
        if(!finalItem?.far_end_date){
          arr.push(finalItem)
        }
      })
    })
    setFinalData(arr)
   }
  },[data])

  return (
    finalData?.length>0 ? <div className="form-group">
      <h6>ASSET DETAILS</h6>

      <div>
      { finalData?.map((item:any)=>{
        return <div className="row mt-1">
        <div className="col-md-6">
          <label htmlFor="linkedinProfile">Asset Description</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="linkedin_profile"
              disabled={!isEdit}
              value={item?.far_it_assets_assigned?.asset_description ||""}
            //   onChange={fixedAssetDetails}
            />
          </div>
        </div>
        <div className="col-md-2">
          <label htmlFor="twitterId">Start Date</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="twitter_id"
              disabled={!isEdit}
              value={item?.far_start_date ? formatDate(item?.far_start_date) : ""||""}
            //   onChange={fixedAssetDetails}
            />
          </div>
        </div>

      </div>
      })}
      </div>
   
     
    </div> : <div></div>
  );
};

export default FixedAssetDetails;
